import React, { ReactElement } from "react";
import cn from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogActions from "@material-ui/core/DialogActions";

import { useModal } from "../../hooks/useModal";

import styles from "./styles.mod.scss";

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

interface CustomizedDialogsProps {
  agreementLinkClassName?: string;
  withoutCopyright?: boolean;
}

export const CustomizedDialogs = ({
  agreementLinkClassName,
  withoutCopyright,
}: CustomizedDialogsProps): ReactElement => {
  const { open, agreementContent, handleClickOpen, handleClose } = useModal();

  const agreementLinkCn = cn(
    styles.footer__agreementsLinks,
    agreementLinkClassName
  );

  const agreementsWithoutCopyright = withoutCopyright
    ? styles.footer__agreementsWithoutCopyright
    : "";

  const agreementsLinksWrapperCn = cn(
    agreementsWithoutCopyright,
    styles.footer__agreementsLinksWrapper
  );

  return (
    <div id="modal" className={agreementsLinksWrapperCn}>
      <a
        href="#agb"
        className={agreementLinkCn}
        onClick={handleClickOpen("agb")}
      >
        AGB
      </a>
      <a
        href="#datenschutz"
        onClick={handleClickOpen("datenschutz")}
        className={agreementLinkCn}
      >
        Datenschutz
      </a>
      <a
        href="#widerruf"
        onClick={handleClickOpen("widerruf")}
        className={agreementLinkCn}
      >
        Widerruf
      </a>
      {!withoutCopyright && (
        <a
          href="#impressum"
          onClick={handleClickOpen("impressum")}
          className={agreementLinkCn}
        >
          Impressum
        </a>
      )}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        {agreementContent}
        <DialogActions>
          <Button onClick={handleClose} variant="contained">
            Schließen
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
